import { forwardRef, type Ref, type SVGProps } from "react";
const IconIdBadgeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M14.884 13.302a2.256 2.256 0 0 1 3.383 1.954v.46a3.14 3.14 0 0 1-.967 2.188l.644.13c1.528.36 2.578 1.134 2.579 2.032v3.29a.645.645 0 0 1-.645.644h-7.733a.645.645 0 0 1-.645-.645v-3.289c0-.898 1.05-1.672 2.578-2.033.012-.002.426-.094.645-.129a3.12 3.12 0 0 1-.967-2.187v-.461c0-.806.43-1.551 1.128-1.954" />
    <path d="M17 7a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2z" />
    <path
      fillRule="evenodd"
      d="M22 4a2 2 0 0 1 2 2v20l-.01.204A2 2 0 0 1 22 28H10l-.204-.01a2 2 0 0 1-1.785-1.786L8 26V6a2 2 0 0 1 1.796-1.99L10 4zM10 26h12V6H10z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconIdBadgeOutlineSVG);
ForwardRef.displayName = "IconIdBadgeOutline";
export { ForwardRef as IconIdBadgeOutline };
